import { getArgsAsTypesafeObjectProperties } from '../constants-util';

export const constants = getArgsAsTypesafeObjectProperties(
	'CREATE_UNIT_TRACKER',
	'GET_UNIT_TRACKER',
	'UPDATE_UNIT_TRACKER_ID',
	'DELETE_UNIT_TRACKER',
	'GET_UNIT_TRACKERS'
);
